import React from 'react';

export default function Controls({ players, newPlayer, setNewPlayer, clickAddPlayer, clickDeletePlayer }) {
  return <form id="controls" onSubmit={clickAddPlayer}>
    <ul>
    { Array.from(players.keys()).map(player =>
      <li key={player} style={{color: players.get(player)}}>
        <hr style={{
            verticalAlign: 'middle',
            display: 'inline-block',
            width: '40px',
            height: 0,
            marginRight: '1ch',
            border: '1px solid',
            borderColor: players.get(player)}}/>

        {player}

        <button onClick={event => clickDeletePlayer(player, event)}>-</button>
      </li>
    ) }
    <li>
      <span></span>
      <input
        value={newPlayer}
        onChange={event => setNewPlayer(event.target.value)}
        placeholder="Enter new player..."
      />
      <input type="submit" value="+" />
    </li>
    </ul>
    </form>;
}
